import * as React from "react";
import * as ReactDOM from "react-dom";

import { RootApplication } from "./RootApplication";

const targetElement = document.createElement("div");
document.body.appendChild(targetElement);
ReactDOM.render(<RootApplication />, targetElement);
